module.exports = __webpack_public_path__ + "media/images/default/shared/header/logo-black-6a4649b1ff2a5fc107e63a35fd97abab.svg";